import React from 'react';
import { Upload, FileText, Calendar, Clock, CheckCircle2, ChevronDown, Wallet, DollarSign, TrendingUp, BarChart3, Building2 } from 'lucide-react';
import { BarChart, Bar, LineChart, Line, AreaChart, Area, PieChart, Pie, Cell, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
// This is a copy of FinancialsTab.tsx but with Wonka-specific trade spend data for Food & Beverage industry
// Card Revenue Data (Monthly Revenue in Millions, Jan-22 to Mar-25)
const cardRevenueData = [{
  month: 'Jan-22',
  revenue: 3.2
}, {
  month: 'Feb-22',
  revenue: 3.3
}, {
  month: 'Mar-22',
  revenue: 3.4
}, {
  month: 'Apr-22',
  revenue: 3.3
}, {
  month: 'May-22',
  revenue: 3.5
}, {
  month: 'Jun-22',
  revenue: 3.5
}, {
  month: 'Jul-22',
  revenue: 3.6
}, {
  month: 'Aug-22',
  revenue: 3.6
}, {
  month: 'Sep-22',
  revenue: 3.7
}, {
  month: 'Oct-22',
  revenue: 3.7
}, {
  month: 'Nov-22',
  revenue: 3.8
}, {
  month: 'Dec-22',
  revenue: 3.8
}, {
  month: 'Jan-23',
  revenue: 3.5
}, {
  month: 'Feb-23',
  revenue: 3.6
}, {
  month: 'Mar-23',
  revenue: 3.7
}, {
  month: 'Apr-23',
  revenue: 3.6
}, {
  month: 'May-23',
  revenue: 3.7
}, {
  month: 'Jun-23',
  revenue: 3.8
}, {
  month: 'Jul-23',
  revenue: 3.9
}, {
  month: 'Aug-23',
  revenue: 3.8
}, {
  month: 'Sep-23',
  revenue: 4.0
}, {
  month: 'Oct-23',
  revenue: 4.0
}, {
  month: 'Nov-23',
  revenue: 4.1
}, {
  month: 'Dec-23',
  revenue: 4.1
}, {
  month: 'Jan-24',
  revenue: 3.8
}, {
  month: 'Feb-24',
  revenue: 3.8
}, {
  month: 'Mar-24',
  revenue: 4.0
}, {
  month: 'Apr-24',
  revenue: 3.9
}, {
  month: 'May-24',
  revenue: 4.0
}, {
  month: 'Jun-24',
  revenue: 4.1
}, {
  month: 'Jul-24',
  revenue: 4.2
}, {
  month: 'Aug-24',
  revenue: 4.1
}, {
  month: 'Sep-24',
  revenue: 4.3
}, {
  month: 'Oct-24',
  revenue: 4.3
}, {
  month: 'Nov-24',
  revenue: 4.4
}, {
  month: 'Dec-24',
  revenue: 4.4
}, {
  month: 'Jan-25',
  revenue: 4.1
}, {
  month: 'Feb-25',
  revenue: 4.2
}, {
  month: 'Mar-25',
  revenue: 4.3
}];
const dbtData = [{
  month: 'Oct-24',
  dbt: 7,
  industry: 12,
  yourAR: 3
}, {
  month: 'Nov-24',
  dbt: 6,
  industry: 11,
  yourAR: 2
}, {
  month: 'Dec-24',
  dbt: 5,
  industry: 10,
  yourAR: 2
}, {
  month: 'Jan-25',
  dbt: 10,
  industry: 10,
  yourAR: 4
}, {
  month: 'Feb-25',
  dbt: 8,
  industry: 9,
  yourAR: 3
}, {
  month: 'Mar-25',
  dbt: 6,
  industry: 9,
  yourAR: 2
}, {
  month: 'Apr-25',
  dbt: 9,
  industry: 9,
  yourAR: 3
}, {
  month: 'May-25',
  dbt: 8,
  industry: 9,
  yourAR: 2
}, {
  month: 'Jun-25',
  dbt: 7,
  industry: 9,
  yourAR: 2
}, {
  month: 'Jul-25',
  dbt: 7,
  industry: 9,
  yourAR: 3
}, {
  month: 'Aug-25',
  dbt: 11,
  industry: 10,
  yourAR: 4
}];
const paidData = [{
  name: 'Current',
  value: 28500000
}, {
  name: '1-30',
  value: 1200000
}, {
  name: '31-60',
  value: 85000
}, {
  name: '61-90',
  value: 12000
}, {
  name: '91+',
  value: 3000
}];
const outstandingData = [{
  name: 'Current',
  value: 1650000
}, {
  name: '1-30',
  value: 180000
}, {
  name: '31-60',
  value: 15000
}, {
  name: '61-90',
  value: 5000
}, {
  name: '91+',
  value: 0
}];
// Trade Spend by Industry Data - WONKA SPECIFIC (Food & Beverage)
const tradeSpendData = [{
  name: 'Food & Beverage Manufacturing',
  value: 850000,
  color: '#4f46e5',
  percentage: 46
}, {
  name: 'Retail & Distribution',
  value: 620000,
  color: '#10b981',
  percentage: 33
}, {
  name: 'Packaging & Supplies',
  value: 380000,
  color: '#9ca3af',
  percentage: 21
}];
// Payment Aging by Industry Data - WONKA SPECIFIC
const paymentAgingData = [{
  industry: 'Food & Beverage Manufacturing',
  total: '$850K',
  trades: 18,
  current: 94,
  days1to30: 5,
  days31to60: 1,
  days61to90: 0,
  days91plus: 0
}, {
  industry: 'Retail & Distribution',
  total: '$620K',
  trades: 42,
  current: 96,
  days1to30: 4,
  days31to60: 0,
  days61to90: 0,
  days91plus: 0
}, {
  industry: 'Packaging & Supplies',
  total: '$380K',
  trades: 28,
  current: 93,
  days1to30: 6,
  days31to60: 1,
  days61to90: 0,
  days91plus: 0
}];
export function WonkaFinancialsTab() {
  return <div className="space-y-6 mt-6" data-id="element-3763" data-mp="2stokqpd1bjyl">
      {/* Financial Statement Analysis */}
      <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-8" data-id="element-3764" data-mp="2wu8hvsxlynkq">
        <div className="flex justify-between items-start mb-8" data-id="element-3765" data-mp="2p8369z681e1f">
          <h2 className="text-xl font-bold text-gray-900" data-id="element-3766" data-mp="2kat9tzkf0243">
            Financial Statement Analysis
          </h2>
          <button className="bg-indigo-600 hover:bg-indigo-700 text-white px-5 py-2.5 rounded-lg flex items-center gap-2 font-medium text-sm transition-colors" data-id="element-3767" data-mp="2z7u161yp1v21">
            <Upload className="w-4 h-4" data-id="element-3768" data-mp="26iwme8toyge1" />
            UPLOAD FINANCIAL STATEMENT
          </button>
        </div>

        {/* Financial Statement Box */}
        <div className="border border-gray-200 bg-gray-50 rounded-lg p-5 mb-8" data-id="element-3769" data-mp="21l4sj99hkk77">
          <p className="text-sm font-medium text-gray-500 mb-3 uppercase tracking-wider" data-id="element-3770" data-mp="2g8ydl9hccex6">
            Latest Financial Statement
          </p>
          <div className="flex items-center justify-between bg-white p-4 rounded border border-gray-200 shadow-sm" data-id="element-3771" data-mp="2bfwraget1d3k">
            <div className="flex items-center gap-6" data-id="element-3772" data-mp="1itc1hkdz9924">
              <div className="flex items-center gap-3" data-id="element-3773" data-mp="1isj43a0wrvwn">
                <div className="w-10 h-10 bg-indigo-50 rounded-lg flex items-center justify-center" data-id="element-3774" data-mp="28hpt47kezqq1">
                  <FileText className="w-5 h-5 text-indigo-600" data-id="element-3775" data-mp="2citbb0pxpyuf" />
                </div>
                <span className="font-semibold text-gray-900 text-lg" data-id="element-3776" data-mp="2h9rr7z70gux5">
                  Wonka-Financial-Statement-2025-Q1
                </span>
              </div>
              <div className="h-6 w-px bg-gray-300" data-id="element-3777" data-mp="2m832mecyfdhh"></div>
              <div className="flex items-center gap-2 text-gray-600" data-id="element-3778" data-mp="1pjdkcmxf0iuz">
                <Calendar className="w-4 h-4" data-id="element-3779" data-mp="1tk791iiom1ox" />
                <span className="font-medium" data-id="element-3780" data-mp="1tkysxw2x2azd">2025</span>
              </div>
              <div className="flex items-center gap-2 text-gray-600" data-id="element-3781" data-mp="1yiqsnc9sz1e4">
                <Clock className="w-4 h-4" data-id="element-3782" data-mp="23id8zukxgxr5" />
                <span className="font-medium" data-id="element-3783" data-mp="23jeihumapc6r">Q1</span>
              </div>
            </div>
            <div className="flex items-center gap-3" data-id="element-3784" data-mp="39z8kez2ggfuf">
              <div className="flex items-center gap-1.5 bg-green-50 px-3 py-1.5 rounded-full border border-green-200" data-id="element-3785" data-mp="3a0taochqlcmh">
                <CheckCircle2 className="w-4 h-4 text-green-600" data-id="element-3786" data-mp="139x0p19227gb" />
                <span className="text-green-700 font-medium text-sm" data-id="element-3787" data-mp="13c9fx6nfi3po">
                  Completed
                </span>
              </div>
              <button className="p-2 hover:bg-gray-100 rounded-full transition-colors" data-id="element-3788" data-mp="tjvbg64yuizt">
                <ChevronDown className="w-5 h-5 text-gray-500" data-id="element-3789" data-mp="olk1lveo88hl" />
              </button>
            </div>
          </div>
        </div>

        {/* Ratio Cards - All 5 in one row */}
        <div className="grid grid-cols-1 md:grid-cols-5 gap-4" data-id="element-3790" data-mp="khcdo0g1ewkf">
          {/* Liquidity Ratios */}
          <div className="border border-gray-200 rounded-lg p-4 bg-white shadow-sm hover:shadow-md transition-shadow" data-id="element-3791" data-mp="fmynqdk59hn5">
            <div className="flex items-center gap-2 mb-4" data-id="element-3792" data-mp="5moa4ru7687g">
              <div className="w-8 h-8 bg-blue-50 rounded-lg flex items-center justify-center" data-id="element-3793" data-mp="5o97sqbt679j">
                <Wallet className="w-4 h-4 text-blue-600" data-id="element-3794" data-mp="24yr10n55i4v5" />
              </div>
              <h3 className="text-sm font-bold text-gray-900" data-id="element-3795" data-mp="201qts8wkew2g">Liquidity</h3>
            </div>
            <div className="space-y-3" data-id="element-3796" data-mp="18w4t84bfoxtd">
              <div className="flex justify-between items-center border-b border-gray-100 pb-2" data-id="element-3797" data-mp="18xfsprxujjeo">
                <span className="text-xs text-gray-600" data-id="element-3798" data-mp="1dwaorvktr4gq">Current Ratio</span>
                <span className="font-bold text-sm text-green-600" data-id="element-3799" data-mp="1029tjbt2zzl4">2.85</span>
              </div>
              <div className="flex justify-between items-center border-b border-gray-100 pb-2" data-id="element-3800" data-mp="142ttso8ybjbh">
                <span className="text-xs text-gray-600" data-id="element-3801" data-mp="q30tq2bjbqqu">Quick Ratio</span>
                <span className="font-bold text-sm text-green-600" data-id="element-3802" data-mp="v3yk326p7r3f">2.41</span>
              </div>
              <div className="flex justify-between items-center" data-id="element-3803" data-mp="h4p70bdshd3o">
                <span className="text-xs text-gray-600" data-id="element-3804" data-mp="l5iu52jeqnvi">Working Capital</span>
                <span className="font-bold text-sm text-green-600" data-id="element-3805" data-mp="l7li7h1026xl">$8.6M</span>
              </div>
            </div>
          </div>

          {/* Cash Flow Ratios */}
          <div className="border border-gray-200 rounded-lg p-4 bg-white shadow-sm hover:shadow-md transition-shadow" data-id="element-3806" data-mp="2fiic32b9fu5y">
            <div className="flex items-center gap-2 mb-4" data-id="element-3807" data-mp="3wg8s76uk81o">
              <div className="w-8 h-8 bg-green-50 rounded-lg flex items-center justify-center" data-id="element-3808" data-mp="3w0s7ukrohyog">
                <DollarSign className="w-4 h-4 text-green-600" data-id="element-3809" data-mp="dmj80p4kai8g" />
              </div>
              <h3 className="text-sm font-bold text-gray-900" data-id="element-3810" data-mp="8vjdtrmtue9n">Cash Flow</h3>
            </div>
            <div className="space-y-3" data-id="element-3811" data-mp="nk5wa27r3m53">
              <div className="flex justify-between items-center border-b border-gray-100 pb-2" data-id="element-3812" data-mp="niuprumx80aa">
                <span className="text-xs text-gray-600" data-id="element-3813" data-mp="ik1du6na8hc8">Op. Cash Flow</span>
                <span className="font-bold text-sm text-gray-900" data-id="element-3814" data-mp="wldp44rhzurs">1.52</span>
              </div>
              <div className="flex justify-between items-center border-b border-gray-100 pb-2" data-id="element-3815" data-mp="rl99egyez42m">
                <span className="text-xs text-gray-600" data-id="element-3816" data-mp="2ybp63orcplop">Free Cash Flow</span>
                <span className="font-bold text-sm text-green-600" data-id="element-3817" data-mp="2ye1uokrm6uaq">$2.4M</span>
              </div>
              <div className="flex justify-between items-center" data-id="element-3818" data-mp="2tfiaopwkzsl0">
                <span className="text-xs text-gray-600" data-id="element-3819" data-mp="3r0wsftktffd4">CF Coverage</span>
                <span className="font-bold text-sm text-green-600" data-id="element-3820" data-mp="3lz7h0ctokzoi">12.35</span>
              </div>
            </div>
          </div>

          {/* Profitability Ratios */}
          <div className="border border-gray-200 rounded-lg p-4 bg-white shadow-sm hover:shadow-md transition-shadow" data-id="element-3821" data-mp="3czu57di33z0m">
            <div className="flex items-center gap-2 mb-4" data-id="element-3822" data-mp="dkp2ptd5cnwg">
              <div className="w-8 h-8 bg-purple-50 rounded-lg flex items-center justify-center" data-id="element-3823" data-mp="dm9zlpmxoixh">
                <TrendingUp className="w-4 h-4 text-purple-600" data-id="element-3824" data-mp="9l7xn11mtsrt" />
              </div>
              <h3 className="text-sm font-bold text-gray-900" data-id="element-3825" data-mp="4qanfqsm9ddc">Profitability</h3>
            </div>
            <div className="space-y-3" data-id="element-3826" data-mp="3vy6i9ac49t1h">
              <div className="flex justify-between items-center border-b border-gray-100 pb-2" data-id="element-3827" data-mp="x86dbwhxgwoo">
                <span className="text-xs text-gray-600" data-id="element-3828" data-mp="shznxufld85d">Net Margin</span>
                <span className="font-bold text-sm text-green-600" data-id="element-3829" data-mp="sfvaolvsywsf">0.08</span>
              </div>
              <div className="flex justify-between items-center border-b border-gray-100 pb-2" data-id="element-3830" data-mp="zuytih4dnqts">
                <span className="text-xs text-gray-600" data-id="element-3831" data-mp="14u1t3m1l94ud">ROE</span>
                <span className="font-bold text-sm text-green-600" data-id="element-3832" data-mp="19q8zffxwcicu">0.18</span>
              </div>
              <div className="flex justify-between items-center" data-id="element-3833" data-mp="1dtf2keppptf3">
                <span className="text-xs text-gray-600" data-id="element-3834" data-mp="1is06ao46av8a">Gross Margin</span>
                <span className="font-bold text-sm text-green-600" data-id="element-3835" data-mp="1ipw01zisxk4u">0.32</span>
              </div>
            </div>
          </div>

          {/* Efficiency Ratios */}
          <div className="border border-gray-200 rounded-lg p-4 bg-white shadow-sm hover:shadow-md transition-shadow" data-id="element-3836" data-mp="1si1t7cksi7lm">
            <div className="flex items-center gap-2 mb-4" data-id="element-3837" data-mp="1xipgbn5we4ak">
              <div className="w-8 h-8 bg-orange-50 rounded-lg flex items-center justify-center" data-id="element-3838" data-mp="21j9caneqj1v4">
                <BarChart3 className="w-4 h-4 text-orange-600" data-id="element-3839" data-mp="26ickuhtxbq7u" />
              </div>
              <h3 className="text-sm font-bold text-gray-900" data-id="element-3840" data-mp="6ejpip6h6mg9">Efficiency</h3>
            </div>
            <div className="space-y-3" data-id="element-3841" data-mp="2dzvvvl420yv">
              <div className="flex justify-between items-center border-b border-gray-100 pb-2" data-id="element-3842" data-mp="2f1a28xfb3kt">
                <span className="text-xs text-gray-600" data-id="element-3843" data-mp="g6frwcflgyqa">Inv. Turnover</span>
                <span className="font-bold text-sm text-green-600" data-id="element-3844" data-mp="bd3g52w0kmey">8.50</span>
              </div>
              <div className="flex justify-between items-center border-b border-gray-100 pb-2" data-id="element-3845" data-mp="q299wbc31kfg">
                <span className="text-xs text-gray-600" data-id="element-3846" data-mp="l4r0kju5l36x">AR Turnover</span>
                <span className="font-bold text-sm text-green-600" data-id="element-3847" data-mp="z3gyu2spl8wv">10.20</span>
              </div>
              <div className="flex justify-between items-center" data-id="element-3848" data-mp="u4vx1yxt6h6b">
                <span className="text-xs text-gray-600" data-id="element-3849" data-mp="u5fj9ruhrrq5">DSO</span>
                <span className="font-bold text-sm text-gray-900" data-id="element-3850" data-mp="30w538fh3a2e8">35.78</span>
              </div>
            </div>
          </div>

          {/* Solvency Ratios */}
          <div className="border border-gray-200 rounded-lg p-4 bg-white shadow-sm hover:shadow-md transition-shadow" data-id="element-3851" data-mp="1be89kl75ha7f">
            <div className="flex items-center gap-2 mb-4" data-id="element-3852" data-mp="1gdb43bpi7y15">
              <div className="w-8 h-8 bg-teal-50 rounded-lg flex items-center justify-center" data-id="element-3853" data-mp="1gevzf3jn7l02">
                <Building2 className="w-4 h-4 text-teal-600" data-id="element-3854" data-mp="12jk2cpi0lifz" />
              </div>
              <h3 className="text-sm font-bold text-gray-900" data-id="element-3855" data-mp="16lf5lzjia5we">Solvency</h3>
            </div>
            <div className="space-y-3" data-id="element-3856" data-mp="slvz1b6cf2m7">
              <div className="flex justify-between items-center border-b border-gray-100 pb-2" data-id="element-3857" data-mp="xmjz0mcjutsk">
                <span className="text-xs text-gray-600" data-id="element-3858" data-mp="jmsf64zcqj6n">Debt-to-Equity</span>
                <span className="font-bold text-sm text-gray-900" data-id="element-3859" data-mp="jovejfme9oo1">0.65</span>
              </div>
              <div className="flex justify-between items-center border-b border-gray-100 pb-2" data-id="element-3860" data-mp="nqglkkc8z8qb">
                <span className="text-xs text-gray-600" data-id="element-3861" data-mp="2e1las408j9yl">Z-Score</span>
                <span className="font-bold text-sm text-green-600" data-id="element-3862" data-mp="2i1dg87uc0zzq">3.42</span>
              </div>
              <div className="flex justify-between items-center" data-id="element-3863" data-mp="1tapqj2s62zgk">
                <span className="text-xs text-gray-600" data-id="element-3864" data-mp="1ocxo3etwbuy4">Int. Coverage</span>
                <span className="font-bold text-sm text-green-600" data-id="element-3865" data-mp="1oatm52fk560h">18.50</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Card Revenue Metrics */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-6" data-id="element-3866" data-mp="1egkvyle01p5h">
        <h2 className="text-xl font-bold text-gray-900 mb-6" data-id="element-3867" data-mp="1aeg2pnrgqujd">
          Card Revenue Metrics
        </h2>

        {/* Summary Stats - More compact layout */}
        <div className="flex flex-wrap justify-between items-center gap-4 mb-6 bg-gray-50 p-4 rounded-lg border border-gray-100" data-id="element-3868" data-mp="10mk5eex7b8g7">
          <div className="flex flex-col" data-id="element-3869" data-mp="vpbnmffyt6fh">
            <span className="text-2xl font-bold text-gray-900 mb-0.5" data-id="element-3870" data-mp="qow8bic4houv">
              $5.1M
            </span>
            <span className="text-xs font-medium text-gray-500 uppercase tracking-wide" data-id="element-3871" data-mp="mnkgd65s0rji">
              Annual Card Revenue
            </span>
          </div>
          <div className="w-px h-8 bg-gray-200 hidden md:block" data-id="element-3872" data-mp="2yae6onpq132g"></div>
          <div className="flex flex-col" data-id="element-3873" data-mp="32b7vrkewgnwx">
            <span className="text-2xl font-bold text-gray-900 mb-0.5" data-id="element-3874" data-mp="32ec66ziykfw1">
              6.8K
            </span>
            <span className="text-xs font-medium text-gray-500 uppercase tracking-wide" data-id="element-3875" data-mp="379j75zkuf6h9">
              Transactions
            </span>
          </div>
          <div className="w-px h-8 bg-gray-200 hidden md:block" data-id="element-3876" data-mp="2enpy588yevm1"></div>
          <div className="flex flex-col" data-id="element-3877" data-mp="2jlhymqnnzq1u">
            <span className="text-2xl font-bold text-gray-900 mb-0.5" data-id="element-3878" data-mp="2jmaz59w15jbj">
              $750
            </span>
            <span className="text-xs font-medium text-gray-500 uppercase tracking-wide" data-id="element-3879" data-mp="2ojjj9g0qnxff">
              Avg Ticket Size
            </span>
          </div>
          <div className="w-px h-8 bg-gray-200 hidden md:block" data-id="element-3880" data-mp="1vwp2ou71li78"></div>
          <div className="flex flex-col" data-id="element-3881" data-mp="1vucjyetgn3t4">
            <span className="text-2xl font-bold text-gray-900 mb-0.5" data-id="element-3882" data-mp="20u8elng9piw0">
              0 - 28
            </span>
            <span className="text-xs font-medium text-gray-500 uppercase tracking-wide" data-id="element-3883" data-mp="1st9gwps3ccbb">
              Daily Transactions
            </span>
          </div>
          <div className="w-px h-8 bg-gray-200 hidden md:block" data-id="element-3884" data-mp="22k44bxh2phyc"></div>
          <div className="flex flex-col" data-id="element-3885" data-mp="22mhx1zoa6i2q">
            <span className="text-2xl font-bold text-green-600 mb-0.5" data-id="element-3886" data-mp="1xksm0k1264en">
              +6%
            </span>
            <span className="text-xs font-medium text-gray-500 uppercase tracking-wide" data-id="element-3887" data-mp="19uyac5sh6lvz">
              YoY Growth
            </span>
          </div>
        </div>

        {/* Area Chart */}
        <div className="h-80 w-full" data-id="element-3888" data-mp="1jufdogk98nos">
          <ResponsiveContainer width="100%" height="100%" data-id="element-3889" data-mp="1jvgyvduziqk8">
            <AreaChart data={cardRevenueData} margin={{
            top: 5,
            right: 0,
            left: 0,
            bottom: 0
          }} data-id="element-3890" data-mp="1eu9rvh0o1vem">
              <defs data-id="element-3891" data-mp="2q8wtnb36wrjz">
                <linearGradient id="colorRevenue" x1="0" y1="0" x2="0" y2="1" data-id="element-3892" data-mp="2q9gdwygbbs16">
                  <stop offset="5%" stopColor="#4f46e5" stopOpacity={0.3} data-id="element-3893" data-mp="c15qqs2ftox9" />
                  <stop offset="95%" stopColor="#4f46e5" stopOpacity={0} data-id="element-3894" data-mp="h1ten4vddpn9" />
                </linearGradient>
              </defs>
              <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e5e7eb" data-id="element-3895" data-mp="32tykllxaj2p" />
              <XAxis dataKey="month" axisLine={true} tickLine={true} tick={{
              fontSize: 12,
              fill: '#6b7280'
            }} interval={3} dy={10} data-id="element-3896" data-mp="vq69fyiq12g6" />
              <YAxis axisLine={true} tickLine={true} tick={{
              fontSize: 12,
              fill: '#6b7280'
            }} domain={[0, 8]} ticks={[0, 2, 4, 6, 8]} tickFormatter={value => `$${value}M`} data-id="element-3897" data-mp="qzhjwoqlqfjo" />
              <Tooltip formatter={(value: any) => `$${Number(value).toFixed(1)}M`} contentStyle={{
              borderRadius: '8px',
              border: '1px solid #e5e7eb',
              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
              padding: '12px'
            }} data-id="element-3898" data-mp="3fjyn74ghuawa" />
              <Area type="monotone" dataKey="revenue" stroke="#4f46e5" strokeWidth={3} fillOpacity={1} fill="url(#colorRevenue)" activeDot={{
              r: 6,
              fill: '#4f46e5',
              stroke: '#fff',
              strokeWidth: 2
            }} data-id="element-3899" data-mp="30s68muoix0vm" />
            </AreaChart>
          </ResponsiveContainer>
        </div>
      </div>

      {/* Trade Payment Information */}
      <div className="grid grid-cols-1 lg:grid-cols-5 gap-8" data-id="element-3900" data-mp="292l9ompmhkd6">
        {/* Trade Credit */}
        <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-6 lg:col-span-2" data-id="element-3901" data-mp="olc1yzp22itq">
          <h2 className="text-xl font-bold text-gray-900 mb-6" data-id="element-3902" data-mp="slvyq25pvkfc">Trade Credit</h2>
          <div className="grid grid-cols-2 gap-x-6 gap-y-4" data-id="element-3903" data-mp="xlh0slg6o8wa">
            <div className="flex flex-col border-b border-gray-100 pb-3" data-id="element-3904" data-mp="xjxkwvyfvzv1">
              <span className="text-2xl font-bold text-gray-900 mb-0.5" data-id="element-3905" data-mp="12d8qyuvfgclw">
                $50K
              </span>
              <span className="text-xs font-medium text-gray-500" data-id="element-3906" data-mp="17aigeaitgo9q">
                Recommended Credit Limit
              </span>
            </div>
            <div className="flex flex-col border-b border-gray-100 pb-3" data-id="element-3907" data-mp="1gbymw76ig68o">
              <span className="text-2xl font-bold text-gray-900 mb-0.5" data-id="element-3908" data-mp="1g9voayral4sc">3</span>
              <span className="text-xs font-medium text-gray-500" data-id="element-3909" data-mp="1lajeji7p5hli">
                Days Beyond Terms
              </span>
            </div>
            <div className="flex flex-col border-b border-gray-100 pb-3" data-id="element-3910" data-mp="3n2g0zmvekbv2">
              <span className="text-xl font-bold text-gray-900 mb-0.5" data-id="element-3911" data-mp="3n2obj841z533">
                142
              </span>
              <span className="text-xs font-medium text-gray-500" data-id="element-3912" data-mp="36tv1bolynbe8">
                Trade Experiences
              </span>
            </div>
            <div className="flex flex-col border-b border-gray-100 pb-3" data-id="element-3913" data-mp="3gtlwztm9bwfw">
              <span className="text-xl font-bold text-gray-900 mb-0.5" data-id="element-3914" data-mp="3lklx17qoaumm">
                $1.85M
              </span>
              <span className="text-xs font-medium text-gray-500" data-id="element-3915" data-mp="3pmp8hwdcdz7w">
                Total Trades Balance
              </span>
            </div>
            <div className="flex flex-col border-b border-gray-100 pb-3" data-id="element-3916" data-mp="3ujpgwdxnze26">
              <span className="text-xl font-bold text-gray-900 mb-0.5" data-id="element-3917" data-mp="3g0sgvuejizx">
                $275K
              </span>
              <span className="text-xs font-medium text-gray-500" data-id="element-3918" data-mp="8dk37lrw5dn4">
                Recent High Credit
              </span>
            </div>
            <div className="flex flex-col border-b border-gray-100 pb-3" data-id="element-3919" data-mp="2a5fcxvul782p">
              <span className="text-xl font-bold text-gray-900 mb-0.5" data-id="element-3920" data-mp="2a5p0lcs5t358">
                $13.0K
              </span>
              <span className="text-xs font-medium text-gray-500" data-id="element-3921" data-mp="rc5i3lunrchj">
                Average Credit Amount
              </span>
            </div>
            <div className="flex flex-col border-b border-gray-100 pb-3" data-id="element-3922" data-mp="ih7hdsl9qvfn">
              <span className="text-xl font-bold text-gray-900 mb-0.5" data-id="element-3923" data-mp="dj62zkysfkai">
                $12.5K
              </span>
              <span className="text-xs font-medium text-gray-500" data-id="element-3924" data-mp="1a9gduwh2zns8">
                Past Due
              </span>
            </div>
            <div className="flex flex-col border-b border-gray-100 pb-3" data-id="element-3925" data-mp="16838soltbomd">
              <span className="text-xl font-bold text-gray-900 mb-0.5" data-id="element-3926" data-mp="117p7dpepvcxb">
                0.7%
              </span>
              <span className="text-xs font-medium text-gray-500" data-id="element-3927" data-mp="w8m52cq4fkt1">
                Past Due %
              </span>
            </div>
            <div className="flex flex-col" data-id="element-3928" data-mp="3lwmrettnd50s">
              <span className="text-xl font-bold text-gray-900 mb-0.5" data-id="element-3929" data-mp="3gzd4bktqd5g4">$0</span>
              <span className="text-xs font-medium text-gray-500" data-id="element-3930" data-mp="3ih1r5npf89z3">
                Severely Past Due
              </span>
            </div>
            <div className="flex flex-col" data-id="element-3931" data-mp="3nelgpjrkk96c">
              <span className="text-xl font-bold text-gray-900 mb-0.5" data-id="element-3932" data-mp="39g3vptt1tas4">0%</span>
              <span className="text-xs font-medium text-gray-500" data-id="element-3933" data-mp="39i7xo67dzzpr">
                Severely Past Due %
              </span>
            </div>
          </div>
        </div>

        {/* Days Beyond Terms Chart */}
        <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-6 flex flex-col lg:col-span-3" data-id="element-3934" data-mp="2zohcpbagy7et">
          <div className="flex flex-col sm:flex-row sm:justify-between sm:items-start mb-3 gap-3" data-id="element-3935" data-mp="2qpm7o2j5v3d3">
            <h2 className="text-xl font-bold text-gray-900" data-id="element-3936" data-mp="2ur7g9bonwvhh">
              Days Beyond Terms
            </h2>
            <div className="flex flex-wrap items-center gap-3 text-xs bg-gray-50 px-3 py-1.5 rounded-lg border border-gray-100" data-id="element-3937" data-mp="2grpyhg9saihm">
              <div className="flex items-center gap-2" data-id="element-3938" data-mp="2lphqeaafi4lt">
                <div className="w-5 h-0.5 border-t-2 border-dashed border-gray-400" data-id="element-3939" data-mp="224r9rt2ba26l"></div>
                <span className="font-medium text-gray-600" data-id="element-3940" data-mp="226ke31pgcabf">Industry</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-3941" data-mp="1x80rr06y4wij">
                <div className="w-5 h-0.5 bg-gray-900" data-id="element-3942" data-mp="2c3osgfd231ho"></div>
                <span className="font-medium text-gray-900" data-id="element-3943" data-mp="2743tw61ssv5h">DBT</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-3944" data-mp="2l3lnqztyaylp">
                <div className="w-5 h-0.5 bg-indigo-600" data-id="element-3945" data-mp="2l20s16vwh9m9"></div>
                <span className="font-medium text-indigo-600" data-id="element-3946" data-mp="2g5210x7j9isa">Your AR</span>
              </div>
            </div>
          </div>
          <p className="text-xs text-gray-500 mb-6 max-w-md leading-relaxed" data-id="element-3947" data-mp="2us3j31jgodhy">
            Compare how they pay the industry, how they pay their vendors
            generally, and how they pay you.
          </p>
          <div className="flex-1 min-h-[250px] w-full mt-auto" data-id="element-3948" data-mp="33umi1ak4m5yx">
            <ResponsiveContainer width="100%" height="100%" data-id="element-3949" data-mp="2ztaqgzhozao3">
              <LineChart data={dbtData} margin={{
              top: 5,
              right: 10,
              left: -20,
              bottom: 0
            }} data-id="element-3950" data-mp="2zqoiiyqw2t5c">
                <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e5e7eb" data-id="element-3951" data-mp="16v44tzc0hmi7" />
                <XAxis dataKey="month" axisLine={true} tickLine={true} tick={{
                fontSize: 12,
                fill: '#6b7280'
              }} dy={10} data-id="element-3952" data-mp="1bwtebajl5s46" />
                <YAxis axisLine={true} tickLine={true} tick={{
                fontSize: 12,
                fill: '#6b7280'
              }} domain={[0, 15]} ticks={[0, 5, 10, 15]} data-id="element-3953" data-mp="o3urfez4edlc" />
                <Tooltip contentStyle={{
                borderRadius: '8px',
                border: '1px solid #e5e7eb',
                boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
                padding: '12px'
              }} data-id="element-3954" data-mp="23k3f1jw5oyd1" />
                <Line type="monotone" dataKey="industry" name="Industry" stroke="#9ca3af" strokeWidth={2} strokeDasharray="5 5" dot={false} activeDot={{
                r: 6,
                fill: '#9ca3af'
              }} data-id="element-3955" data-mp="3f9sqqsjh0457" />
                <Line type="monotone" dataKey="dbt" name="DBT" stroke="#111827" strokeWidth={2} dot={false} activeDot={{
                r: 6,
                fill: '#111827'
              }} data-id="element-3956" data-mp="2wd1bcu71u96f" />
                <Line type="monotone" dataKey="yourAR" name="Your AR" stroke="#4f46e5" strokeWidth={3} dot={false} activeDot={{
                r: 6,
                fill: '#4f46e5'
              }} data-id="element-3957" data-mp="18qeri8yj44rz" />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>

      {/* Trade Payment Aging - keeping rest of component identical to FinancialsTab */}
      <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-8" data-id="element-3958" data-mp="1wfzcexe8tc3w">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between mb-8 gap-4" data-id="element-3959" data-mp="1ifombwkrc1js">
          <div data-id="element-3960" data-mp="1nerqleswy3qp">
            <h2 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-3961" data-mp="1ne9klqgg8b5l">
              Trade Payment Information
            </h2>
            <div className="flex items-center gap-3 text-sm" data-id="element-3962" data-mp="73nsw4cy7oxp">
              <span className="font-medium text-gray-900 bg-gray-100 px-2.5 py-1 rounded-md" data-id="element-3963" data-mp="c1pbypadjo96">
                Total Trade Lines: 142
              </span>
              <span className="text-gray-500" data-id="element-3964" data-mp="3vng1ewt2zqmg">
                Updated Monthly - Next Update 04/01/2026
              </span>
            </div>
          </div>
        </div>

        {/* Table */}
        <div className="overflow-x-auto mb-10 border border-gray-200 rounded-xl" data-id="element-3965" data-mp="dfgsj74l5vpo">
          <table className="w-full text-left border-collapse" data-id="element-3966" data-mp="8gnftgx4i8qk">
            <thead data-id="element-3967" data-mp="3gzl8bfb5vk8u">
              <tr className="bg-gray-50 border-b border-gray-200" data-id="element-3968" data-mp="3gz37049n6fu2">
                <th className="px-6 py-4 text-sm font-bold text-gray-900" data-id="element-3969" data-mp="3cxre9pvh1ehn">
                  Status
                </th>
                <th className="px-6 py-4 text-sm font-bold text-gray-900 text-right" data-id="element-3970" data-mp="3qpxrb33bv5cv">
                  Current
                </th>
                <th className="px-6 py-4 text-sm font-bold text-gray-900 text-right" data-id="element-3971" data-mp="3lvthmc2ogj83">
                  1-30
                </th>
                <th className="px-6 py-4 text-sm font-bold text-gray-900 text-right" data-id="element-3972" data-mp="2t9im3ftxh8i5">
                  31-60
                </th>
                <th className="px-6 py-4 text-sm font-bold text-gray-900 text-right" data-id="element-3973" data-mp="28ogqyl8xg2co">
                  61-90
                </th>
                <th className="px-6 py-4 text-sm font-bold text-gray-900 text-right" data-id="element-3974" data-mp="2cqtownhfmvyw">
                  91+
                </th>
                <th className="px-6 py-4 text-sm font-bold text-gray-900 text-right bg-gray-100" data-id="element-3975" data-mp="2mmn4ygud17lf">
                  Total
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200" data-id="element-3976" data-mp="2vnle1djno5av">
              <tr className="hover:bg-gray-50/50 transition-colors" data-id="element-3977" data-mp="2vma7x72qmlgl">
                <td className="px-6 py-4 text-sm font-medium text-gray-900" data-id="element-3978" data-mp="30e1r2wjkdowp">
                  Paid
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 text-right" data-id="element-3979" data-mp="35c3a5hgzpo86">
                  $28,500,000
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 text-right" data-id="element-3980" data-mp="3aaej7pzgnupc">
                  $1,200,000
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 text-right" data-id="element-3981" data-mp="13o8u1mxglgec">
                  $85,000
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 text-right" data-id="element-3982" data-mp="yow7l3ai2bca">
                  $12,000
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 text-right" data-id="element-3983" data-mp="tquf5rr6ozo5">
                  $3,000
                </td>
                <td className="px-6 py-4 text-sm font-bold text-gray-900 text-right bg-gray-50" data-id="element-3984" data-mp="ossy1cdbjafb">
                  $29,800,000
                </td>
              </tr>
              <tr className="hover:bg-gray-50/50 transition-colors" data-id="element-3985" data-mp="1hgoqu5zroi6t">
                <td className="px-6 py-4 text-sm font-medium text-gray-900" data-id="element-3986" data-mp="1conhosxwb7l0">
                  Outstanding
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 text-right" data-id="element-3987" data-mp="17osryspuwo1j">
                  $1,650,000
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 text-right" data-id="element-3988" data-mp="256izscgytmls">
                  $180,000
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 text-right" data-id="element-3989" data-mp="20coitgsqvlqe">
                  $15,000
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 text-right" data-id="element-3990" data-mp="2x4tpp6jvrs05">
                  $5,000
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 text-right" data-id="element-3991" data-mp="3b54fs7dd92k9">
                  $0
                </td>
                <td className="px-6 py-4 text-sm font-bold text-gray-900 text-right bg-gray-50" data-id="element-3992" data-mp="370wr2a6wrmm1">
                  $1,850,000
                </td>
              </tr>
              <tr className="hover:bg-gray-50/50 transition-colors" data-id="element-3993" data-mp="3g3o248vvggd5">
                <td className="px-6 py-4 text-sm font-medium text-gray-900" data-id="element-3994" data-mp="3us2hfjah5xal">
                  Payment Experiences
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 text-right" data-id="element-3995" data-mp="3pspjo3i2f5t8">
                  112
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 text-right" data-id="element-3996" data-mp="7o4gnw1g028n">
                  22
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 text-right" data-id="element-3997" data-mp="2q2wf7sa5wvl">
                  5
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 text-right" data-id="element-3998" data-mp="m88lptxq71rb">
                  2
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 text-right" data-id="element-3999" data-mp="d9n4q37wjusn">
                  1
                </td>
                <td className="px-6 py-4 text-sm font-bold text-gray-900 text-right bg-gray-50" data-id="element-4000" data-mp="ha71v6sh6yes">
                  142
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* Bar Charts */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-4001" data-mp="8bv1id1t4m95">
          {/* Paid Chart */}
          <div className="bg-gray-50 rounded-xl p-6 border border-gray-100" data-id="element-4002" data-mp="3pscx7px9q44o">
            <h3 className="text-lg font-bold text-gray-900 mb-6 flex items-center gap-2" data-id="element-4003" data-mp="3uqwl3vvf9pzo">
              <div className="w-2 h-6 bg-green-600 rounded-full" data-id="element-4004" data-mp="3gptvj957xxk0"></div>
              Paid History
            </h3>
            <div className="h-64 w-full" data-id="element-4005" data-mp="3lo59nw2jqu81">
              <ResponsiveContainer width="100%" height="100%" data-id="element-4006" data-mp="3lqzrrgy382ya">
                <BarChart data={paidData} margin={{
                top: 5,
                right: 10,
                left: 0,
                bottom: 0
              }} data-id="element-4007" data-mp="1r9q9awdpvtm9">
                  <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e5e7eb" data-id="element-4008" data-mp="1dhjvhgy1dypz" />
                  <XAxis dataKey="name" axisLine={true} tickLine={true} tick={{
                  fontSize: 12,
                  fill: '#6b7280'
                }} dy={10} data-id="element-4009" data-mp="2a7170cjpaezl" />
                  <YAxis axisLine={true} tickLine={true} tick={{
                  fontSize: 12,
                  fill: '#6b7280'
                }} tickFormatter={value => `$${value / 1000000}M`} data-id="element-4010" data-mp="1wa5lvlq6cx36" />
                  <Tooltip formatter={(value: any) => `$${(value / 1000000).toFixed(1)}M`} contentStyle={{
                  borderRadius: '8px',
                  border: '1px solid #e5e7eb',
                  boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
                  padding: '12px'
                }} cursor={{
                  fill: '#e5e7eb',
                  opacity: 0.4
                }} data-id="element-4011" data-mp="2weeranl0pkwv" />
                  <Bar dataKey="value" radius={[4, 4, 0, 0]} shape={(props: any) => {
                  const {
                    x,
                    y,
                    width,
                    height,
                    name
                  } = props;
                  let fill = '#16a34a';
                  if (name === '31-60') fill = '#84cc16';
                  if (name === '61-90') fill = '#f59e0b';
                  if (name === '91+') fill = '#dc2626';
                  return <rect x={x} y={y} width={width} height={height} fill={fill} rx={4} ry={4} data-id="element-4013" data-mp="zhh3xv37qar7" />;
                }} data-id="element-4012" data-mp="3p5ewv2yzywqn" />
                </BarChart>
              </ResponsiveContainer>
            </div>
          </div>

          {/* Outstanding Chart */}
          <div className="bg-gray-50 rounded-xl p-6 border border-gray-100" data-id="element-4014" data-mp="uhw5rmvva6fj">
            <h3 className="text-lg font-bold text-gray-900 mb-6 flex items-center gap-2" data-id="element-4015" data-mp="pr62cf704dnh">
              <div className="w-2 h-6 bg-blue-600 rounded-full" data-id="element-4016" data-mp="21bobuay4j1n"></div>
              Outstanding Balance
            </h3>
            <div className="h-64 w-full" data-id="element-4017" data-mp="3t84rh3paus8t">
              <ResponsiveContainer width="100%" height="100%" data-id="element-4018" data-mp="3t73ayjpildjp">
                <BarChart data={outstandingData} margin={{
                top: 5,
                right: 10,
                left: 0,
                bottom: 0
              }} data-id="element-4019" data-mp="28pc0dh7s4zjd">
                  <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e5e7eb" data-id="element-4020" data-mp="1zmt45fyi1l63" />
                  <XAxis dataKey="name" axisLine={true} tickLine={true} tick={{
                  fontSize: 12,
                  fill: '#6b7280'
                }} dy={10} data-id="element-4021" data-mp="2rhd5h1b5dm18" />
                  <YAxis axisLine={true} tickLine={true} tick={{
                  fontSize: 12,
                  fill: '#6b7280'
                }} tickFormatter={value => `$${value / 1000000}M`} data-id="element-4022" data-mp="2ncx4nege54sv" />
                  <Tooltip formatter={(value: any) => `$${(value / 1000000).toFixed(2)}M`} contentStyle={{
                  borderRadius: '8px',
                  border: '1px solid #e5e7eb',
                  boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
                  padding: '12px'
                }} cursor={{
                  fill: '#e5e7eb',
                  opacity: 0.4
                }} data-id="element-4023" data-mp="3dqldszj1906t" />
                  <Bar dataKey="value" radius={[4, 4, 0, 0]} shape={(props: any) => {
                  const {
                    x,
                    y,
                    width,
                    height,
                    name
                  } = props;
                  let fill = '#16a34a';
                  if (name === '31-60') fill = '#84cc16';
                  if (name === '61-90') fill = '#f59e0b';
                  if (name === '91+') fill = '#dc2626';
                  return <rect x={x} y={y} width={width} height={height} fill={fill} rx={4} ry={4} data-id="element-4025" data-mp="223b5znpd62bq" />;
                }} data-id="element-4024" data-mp="2l0uveeadbc4w" />
                </BarChart>
              </ResponsiveContainer>
            </div>
          </div>
        </div>
      </div>

      {/* Trade Spend by Industry Section */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-4026" data-mp="1n5iur7quo03c">
        {/* Trade Spend Donut Chart */}
        <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-8 lg:col-span-1" data-id="element-4027" data-mp="1s66j1lnp22tv">
          <h2 className="text-xl font-bold text-gray-900 mb-6" data-id="element-4028" data-mp="2yko0ylq6wgrp">
            Trade Spend by Industry
          </h2>
          <div className="relative h-64 w-full mb-8" data-id="element-4029" data-mp="33iphp0058400">
            <ResponsiveContainer width="100%" height="100%" data-id="element-4030" data-mp="2f7gu13qi0h13">
              <PieChart data-id="element-4031" data-mp="2f5vut0t8o9ww">
                <Pie data={tradeSpendData} cx="50%" cy="50%" innerRadius={70} outerRadius={100} paddingAngle={2} dataKey="value" stroke="none" data-id="element-4032" data-mp="2a95k6t07e6iv">
                  {tradeSpendData.map((entry, index) => <Cell key={`cell-${index}`} fill={entry.color} data-id="element-4033" data-mp="2y0kqewv3p7ze" data-mpi={index} />)}
                </Pie>
                <Tooltip formatter={(value: any) => `$${(value / 1000).toFixed(0)}K`} contentStyle={{
                borderRadius: '8px',
                border: '1px solid #e5e7eb',
                boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
              }} data-id="element-4034" data-mp="2t1r9eugluyuh" />
              </PieChart>
            </ResponsiveContainer>
            <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none" data-id="element-4035" data-mp="18lmp7bd7box9">
              <span className="text-2xl font-black text-gray-900" data-id="element-4036" data-mp="yhz92z09jx23">$1.85M</span>
              <span className="text-sm font-medium text-gray-500" data-id="element-4037" data-mp="12gf3vp2l69q2">
                Total Spend
              </span>
            </div>
          </div>

          {/* Custom Legend */}
          <div className="flex flex-wrap justify-center gap-x-6 gap-y-3" data-id="element-4038" data-mp="tnbr7izrm0wh">
            {tradeSpendData.map((item, index) => <div key={index} className="flex items-center gap-2" data-id="element-4039" data-mp="etqc8bnrz2w9" data-mpi={index}>
                <div className="w-3 h-3 rounded-full" style={{
              backgroundColor: item.color
            }} data-id="element-4040" data-mp="jri97k3a1f7b"></div>
                <span className="text-sm text-gray-600" data-id="element-4041" data-mp="aqtq4az10onk">
                  {item.name} {item.percentage}%
                </span>
              </div>)}
          </div>
        </div>

        {/* Payment Aging by Industry */}
        <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-8 lg:col-span-2" data-id="element-4042" data-mp="251z0dy4mbzbv">
          <div className="flex justify-between items-center mb-8" data-id="element-4043" data-mp="4dd844yydsxl">
            <h2 className="text-xl font-bold text-gray-900" data-id="element-4044" data-mp="9d81qga44wmc">
              Payment Aging by Industry
            </h2>
            <div className="flex bg-gray-100 rounded-lg p-1" data-id="element-4045" data-mp="3rjw4hzhox7ou">
              <button className="px-3 py-1 text-sm font-medium bg-white shadow-sm rounded-md text-gray-900" data-id="element-4046" data-mp="3vkzj6io04xoh">
                %
              </button>
              <button className="px-3 py-1 text-sm font-medium text-gray-500 hover:text-gray-900" data-id="element-4047" data-mp="3hs9nfmio8ee6">
                $
              </button>
            </div>
          </div>

          <div className="space-y-6" data-id="element-4048" data-mp="37xrdw0qkpomg">
            {paymentAgingData.map((item, index) => <div key={index} className="flex flex-col gap-2" data-id="element-4049" data-mp="3cw1bsj3on3br" data-mpi={index}>
                <div className="flex justify-between items-end" data-id="element-4050" data-mp="2yuymzylazex5">
                  <span className="text-sm font-medium text-gray-700" data-id="element-4051" data-mp="2yxuk5kpbtzkj">
                    {item.industry}
                  </span>
                  <span className="text-sm text-gray-500" data-id="element-4052" data-mp="2k89n3vn52zq8">
                    {item.total} ({item.trades})
                  </span>
                </div>
                {/* Stacked Bar */}
                <div className="h-6 w-full flex rounded-sm overflow-hidden" data-id="element-4053" data-mp="2t97w6scfpxfo">
                  {item.current > 0 && <div style={{
                width: `${item.current}%`
              }} className="bg-[#16a34a] h-full flex items-center justify-center border-r border-white/20 last:border-0" data-id="element-4054" data-mp="2p7mk397q5n6j">
                      {item.current > 10 && <span className="text-[10px] font-bold text-white" data-id="element-4055" data-mp="3cwxhcgpv8zfx">
                          {item.current}%
                        </span>}
                    </div>}
                  {item.days1to30 > 0 && <div style={{
                width: `${item.days1to30}%`
              }} className="bg-[#84cc16] h-full flex items-center justify-center border-r border-white/20 last:border-0" data-id="element-4056" data-mp="3gzk8efepqgc2">
                      {item.days1to30 > 10 && <span className="text-[10px] font-bold text-white" data-id="element-4057" data-mp="2nkrebnc8hp0e">
                          {item.days1to30}%
                        </span>}
                    </div>}
                  {item.days31to60 > 0 && <div style={{
                width: `${item.days31to60}%`
              }} className="bg-[#facc15] h-full flex items-center justify-center border-r border-white/20 last:border-0" data-id="element-4058" data-mp="32ap4g8tq4os8">
                      {item.days31to60 > 10 && <span className="text-[10px] font-bold text-white" data-id="element-4059" data-mp="1cxv4sym93sn7">
                          {item.days31to60}%
                        </span>}
                    </div>}
                  {item.days61to90 > 0 && <div style={{
                width: `${item.days61to90}%`
              }} className="bg-[#f59e0b] h-full flex items-center justify-center border-r border-white/20 last:border-0" data-id="element-4060" data-mp="14n4nb6zki73r">
                      {item.days61to90 > 10 && <span className="text-[10px] font-bold text-white" data-id="element-4061" data-mp="1scp53mjziybg">
                          {item.days61to90}%
                        </span>}
                    </div>}
                  {item.days91plus > 0 && <div style={{
                width: `${item.days91plus}%`
              }} className="bg-[#dc2626] h-full flex items-center justify-center border-r border-white/20 last:border-0" data-id="element-4062" data-mp="1ee8xzui7n5ss">
                      {item.days91plus > 10 && <span className="text-[10px] font-bold text-white" data-id="element-4063" data-mp="1qtfhy5il40gd">
                          {item.days91plus}%
                        </span>}
                    </div>}
                </div>
              </div>)}
          </div>

          <div className="mt-8 text-center border-t border-gray-100 pt-4" data-id="element-4064" data-mp="1lwp1hh2vb2uf">
            <button className="text-indigo-600 text-sm font-medium hover:text-indigo-700 uppercase tracking-wider" data-id="element-4065" data-mp="29l8a5xptxhn1">
              Show More
            </button>
          </div>
        </div>
      </div>
    </div>;
}